import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useHistory, useLocation } from 'react-router-dom';

export const NotificationPopup = ({ visible, onHide, notificationData }) => {
  const history = useHistory();
  const location = useLocation();

  const message = notificationData?.body?.message || '';
  const messageBody = notificationData?.body?.message_body || '';
  const clientName = notificationData?.body?.client_name || '';
  const senderName = notificationData?.body?.sender_name || clientName;
  const isTextMessage =
    notificationData?.notification_type === 'text_message' || notificationData?.notification_type === 'inbound_text_message';

  // Handle nested case_description structure
  const caseDescData = notificationData?.case_description?.case_description || notificationData?.case_description || {};
  const caseName = caseDescData?.case_name || 'N/A';
  const caseNumber = caseDescData?.case_number || 'N/A';
  const route = notificationData?.body?.route || null;

  const handleGoToPage = () => {
    if (route) {
      // Only navigate if not already on the same route
      if (location.pathname !== route) {
        history.push(route);
      }
      onHide();
    }
  };

  return (
    <Dialog
      header="Notification"
      visible={visible}
      style={{ width: '40vw', minWidth: '400px' }}
      onHide={onHide}
      modal
      draggable={false}
      position="center"
    >
      <div className="notification-popup-content">
        {isTextMessage && senderName && (
          <div className="row mb-2">
            <div className="col-12">
              <div className="text-bold text-lg">From: {senderName}</div>
            </div>
          </div>
        )}

        {message && (
          <div className="row mb-3">
            <div className="col-12">
              <div className="text-lg">{message}</div>
            </div>
          </div>
        )}

        {isTextMessage && messageBody && (
          <div className="row mb-3">
            <div className="col-12">
              <div className="p-3 border-round" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="text-sm text-muted mb-1">Message:</div>
                <div>{messageBody}</div>
              </div>
            </div>
          </div>
        )}

        {(caseName !== 'N/A' || caseNumber !== 'N/A') && (
          <div className="row mt-3">
            <div className="col-12">
              <div className="border-top pt-3">
                {caseName !== 'N/A' && (
                  <div className="row mb-2">
                    <div className="col-4 text-bold">Case Name:</div>
                    <div className="col-8">{caseName}</div>
                  </div>
                )}
                {caseNumber !== 'N/A' && (
                  <div className="row">
                    <div className="col-4 text-bold">Case Number:</div>
                    <div className="col-8">{caseNumber}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Buttons at the bottom of content */}
        <div className="row mt-4">
          <div className="col-12">
            <div className="d-flex justify-content-end gap-2">
              <Button label="Close" onClick={onHide} className="p-button-text" />
              {route && <Button label="Go to page" onClick={handleGoToPage} className="p-button-primary" />}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default NotificationPopup;
